import React, { useState } from "react";
import styles from "./PreQualification.module.css";
import Header from "../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ProgressBar from "../../../components/ProgressBar";
import { showErrorToast } from "../../utils";

const PreQualification = () => {
    const [firstQuestionAnswer, setFirstQuestionAnswer] = useState(null);
    const [secondQuestionAnswer, setSecondQuestionAnswer] = useState(null);
    const [thirdQuestionAnswer, setThirdQuestionAnswer] = useState(null);
    const [zipcode, setZipcode] = useState(""); // Zipcode state for ZipCodeInput

    const navigate = useNavigate();
    const location = useLocation();
    const handleOptionClick = (setter, option) => {
        setter(option);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate the form inputs
        if (!firstQuestionAnswer || !secondQuestionAnswer || !thirdQuestionAnswer) {
            showErrorToast("Please answer all questions.");
            return;
        }

        try {
            const timePayload = {
                is_first_time_buyer: firstQuestionAnswer, // Answer for first question
                timeline: thirdQuestionAnswer, // Answer for timeline
                homebuying: secondQuestionAnswer, // Answer for homebuying process stage
                address_data: location.state,
            };

            navigate("/get-qualified/Step-4", { state: timePayload }); // Redirect on success
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    return (
        <div className={`${styles.container} tw-h-screen tw-overflow-y-auto tw-bg-background_color `}>
            <main className={`${styles.mainContent} tw-p-[12px]`}>
                <Header title="Apply For Financing" />
                <div className="tw-w-full tw-mt-5 ">
                    <ProgressBar currentStep={3} totalSteps={6} />
                </div>

                <form className={`${styles.formContainer} tw-w-full max-lg:tw-w-[80%] max-sm:tw-p-0`} onSubmit={handleSubmit}>
                    {/* First Question */}
                    <div className={`${styles.formSection} `}>
                        <h2 className={styles.formQuestion}>Are you a first time home buyer?</h2>

                        <div className={`${styles.optionsContainer} tw-justify-start tw-flex-nowrap`}>
                            {["Yes", "No"].map((option, index) => (
                                <div
                                    key={index}
                                    className={`${styles.option}  tw-font-normal tw-h-fit  tw-text-[14px] tw-py-3 ${firstQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                    onClick={() => handleOptionClick(setFirstQuestionAnswer, option)}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="tw-flex tw-p-0 tw-gap-3 max-sm:tw-flex-wrap">
                        {/* Second Question */}
                        <section className={styles.sectionTwo}>
                            <div className={styles.formRow}>
                                <h2 className={styles.formQuestion}>At what stage are you in your home-buying process?</h2>
                                <div className={styles.optionsList}>
                                    {[
                                        "I'm thinking about buying",
                                        "Touring open houses",
                                        "Making offers on a property",
                                        "I've signed a purchase contract",
                                    ].map((option, optionIndex) => (
                                        <React.Fragment key={optionIndex}>
                                            <input
                                                type="radio"
                                                id={`secondQuestion-option${optionIndex}`}
                                                name="secondQuestion"
                                                value={option}
                                                className={styles["visually-hidden"]}
                                                onChange={() => handleOptionClick(setSecondQuestionAnswer, option)}
                                            />
                                            <label
                                                htmlFor={`secondQuestion-option${optionIndex}`}
                                                className={`${styles.optionItem} tw-font-normal ${secondQuestionAnswer === option ? "tw-bg-primary  hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                            >
                                                {option}
                                            </label>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </section>

                        {/* Third Question */}
                        <section className={styles.sectionTwo}>
                            <div className={styles.formRow}>
                                <h2 className={styles.formQuestion}>What is your timeline for purchasing a home?</h2>
                                <div className={styles.optionsList}>
                                    {["0-3 months", "4-6 months", "7+ months", "Not sure"].map((option, optionIndex) => (
                                        <React.Fragment key={optionIndex}>
                                            <input
                                                type="radio"
                                                id={`thirdQuestion-option${optionIndex}`}
                                                name="thirdQuestion"
                                                value={option}
                                                className={styles["visually-hidden"]}
                                                onChange={() => handleOptionClick(setThirdQuestionAnswer, option)}
                                            />
                                            <label
                                                htmlFor={`thirdQuestion-option${optionIndex}`}
                                                className={`${styles.optionItem} ${thirdQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                            >
                                                {option}
                                            </label>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="tw-w-full tw-flex tw-justify-center">
                        <button
                            type="submit"
                            className="tw-w-fit tw-px-[40px]  tw-bg-primary hover:tw-bg-primary_hover tw-text-white tw-py-3 tw-rounded-md tw-font-normal tw-mt-3"
                        >
                            <span className={styles.submitButtonText}>Next</span>
                        </button>
                    </div>
                </form>
            </main>
        </div>
    );
};

export default PreQualification;
